import React, { useState, useEffect } from 'react';
import './App.css';
import './Hero.css';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import { CartProvider, useCart } from './CartContext';
import Courses from './Courses';
import Checkout from './Checkout';
import ThankYou from './ThankYou';
import Books from './Books';
import BooksCheckout from './BooksCheckout';
import BooksThankYou from './BooksThankYou';
import BookDetail from './BookDetail';
import AddToCartNotification from './AddToCartNotification';
import ArtPrints from './ArtPrints';
import Consultations from './Consultations';
import Planner from './Planner';
import Account from './Account';
import Guide from './Guide';
import AboutMana from './AboutMana';
import Shop from './Shop';
import Admin from './Admin';
import Cart from './Cart';
import Login from './Login';
import SignUp from './SignUp';
import WhatsAppButton from './WhatsAppButton';
import { useAuth } from './AuthContext';
import { bookProducts } from './bookData';

function Header({ isMobileMenuOpen, setIsMobileMenuOpen, toggleMobileMenu }) {
  const { getCartCount } = useCart();
  const { user, signOut, loading: authLoading } = useAuth();
  const cartCount = getCartCount();
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    await signOut();
    navigate('/');
  };
  
  const goToCart = () => {
    navigate('/cart');
  };
  
  return (
    <header className="new-header">
      <div className="header-left">
        <img 
          src="/images/Whats-App-Image-2025-12-18-at-9-50-29-AM (1).jpg" 
          alt="Life Force Dynamics Logo" 
          className="header-logo"
        />
      </div>
      <div className="header-right">
        <div className="desktop-menu">
          <ul className="desktop-menu-list">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about-mana">About Mana</Link></li>
            <li><Link to="/books">Books & Oracle Decks</Link></li>
            <li><Link to="/consultations">Consultations</Link></li>
            <li><Link to="/guide">Meet Your Guide</Link></li>
            {user && !authLoading ? (
              <>
                <li><Link to="/account">My Account</Link></li>
                <li><button onClick={handleLogout} className="header-logout-btn">Logout</button></li>
              </>
            ) : !authLoading ? (
              <li><Link to="/login">Login</Link></li>
            ) : null}
            <li className="cart-menu-item">
              <button 
                className="cart-icon-btn" 
                onClick={goToCart}
                aria-label={`Cart (${cartCount} items)`}
              >
                <span className="cart-icon">🛒</span>
                {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
              </button>
            </li>
          </ul>
        </div>
        <div className="mobile-header-buttons">
          <button
            className="mobile-cart-toggle"
            onClick={goToCart}
            aria-label={`Cart (${cartCount} items)`}
          >
            <span className="cart-icon">🛒</span>
            {cartCount > 0 && <span className="cart-badge-mobile">{cartCount}</span>}
          </button>
          <button
            className="mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-menu"
          >
            <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}></span>
          </button>
        </div>
        {isMobileMenuOpen && (
          <div className="mobile-menu-dropdown" id="mobile-menu">
            <ul className="mobile-menu-list">
              <li><Link to="/" onClick={() => setIsMobileMenuOpen(false)}>Home</Link></li>
              <li><Link to="/about-mana" onClick={() => setIsMobileMenuOpen(false)}>About Mana</Link></li>
              <li><Link to="/books" onClick={() => setIsMobileMenuOpen(false)}>Books & Oracle Decks</Link></li>
              <li><Link to="/consultations" onClick={() => setIsMobileMenuOpen(false)}>Consultations</Link></li>
              <li><Link to="/guide" onClick={() => setIsMobileMenuOpen(false)}>Meet Your Guide</Link></li>
              {user && !authLoading ? (
                <>
                  <li><Link to="/account" onClick={() => setIsMobileMenuOpen(false)}>My Account</Link></li>
                  <li><button onClick={() => { setIsMobileMenuOpen(false); handleLogout(); }} className="header-logout-btn mobile">Logout</button></li>
                </>
              ) : !authLoading ? (
                <li><Link to="/login" onClick={() => setIsMobileMenuOpen(false)}>Login</Link></li>
              ) : null}
            </ul>
          </div>
        )}
      </div>
    </header>
  );
}

function Home({ isMobileMenuOpen, setIsMobileMenuOpen, toggleMobileMenu }) {
  const { addToCart } = useCart();
  const previewBooks = bookProducts.slice(0, 4);
  const navigate = useNavigate();
  const handleHomeAddToCart = (book) => {
    addToCart(book);
  };

  return (
    <div className="main-bg">
      <AddToCartNotification />
      <Header isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} toggleMobileMenu={toggleMobileMenu} />
      <header className="hero-section-new">
        <h1 className="hero-title">Life Force Dynamics</h1>
        <p className="hero-description">A Sacred Space for Spiritual Growth, Healing, and Personal Transformation</p>
        </header>

      <section className="about-section" id="about">
        <h2>About Us</h2>
        <p>
          Life Force Dynamics is dedicated to empowering individuals on their spiritual journey. We offer a sacred online space for growth, healing, and transformation, blending ancient wisdom with modern practices to help you unlock your highest potential.
        </p>
      </section>

      <section className="home-books-section" id="books">
        <div className="home-books-heading">
          <h2>Books & Oracle Decks</h2>
          <p>Bring Mana's guided wisdom into your hands with physical copies of our most requested titles.</p>
        </div>
        <div className="home-books-list">
          {previewBooks.map((book) => (
            <article key={book.key} className="home-book-card" onClick={() => navigate(`/books/${book.key}`)}>
              <img src={book.img} alt={book.title} className="book-img" />
              <h3>{book.title}</h3>
              <p className="book-type">Physical Copy</p>
              <p className="book-price">${book.price}</p>
              <button
                className="book-btn home-book-btn"
                onClick={(event) => {
                  event.stopPropagation();
                  handleHomeAddToCart(book);
                }}
              >
                Add to Cart
              </button>
            </article>
          ))}
        </div>
        <Link to="/books" className="home-books-cta">
          See the full collection
        </Link>
      </section>

      <section className="about-section" id="about">
        <h2>About Us</h2>
        <p>
          Life Force Dynamics is dedicated to empowering individuals on their spiritual journey. We offer a sacred online space for growth, healing, and transformation, blending ancient wisdom with modern practices to help you unlock your highest potential.
        </p>
      </section>

      <section className="features" id="features">
        <div className="feature-card">
          <h2>Intuitive Courses</h2>
          <p>Explore a variety of courses designed to deepen your spiritual journey and unlock your inner wisdom.</p>
        </div>
        <div className="feature-card">
          <h2>Guided Practices</h2>
          <p>Participate in powerful practices and meditations to heal, manifest, and connect with your higher self.</p>
        </div>
        <div className="feature-card">
          <h2>Personal Consultations</h2>
          <p>Receive personalized spiritual guidance and healing sessions tailored to your unique path.</p>
        </div>
        <div className="feature-card">
          <h2>Downloadable Resources</h2>
          <p>Access practical tools, workbooks, and guides to support your ongoing growth and transformation.</p>
        </div>
      </section>

      <section className="testimonials-section" id="testimonials">
        <h2>What Our Clients Say</h2>
        <div className="testimonials">
          <div className="testimonial-card">
            <p>"Life Force Dynamics has been a guiding light on my spiritual path. The courses and practices are truly transformative!"</p>
            <span>- Sarah M.</span>
          </div>
          <div className="testimonial-card">
            <p>“The personal consultations provided me with clarity and healing I never thought possible. Highly recommended!”</p>
            <span>- James T.</span>
          </div>
        </div>
      </section>

      <section className="advertisement-section" id="advertisement">
        <h2>Producer Commercial and Industrial Video Creator & Photographer</h2>
        <div className="ad-card">
          <img 
            src="https://i.postimg.cc/ydcws9rH/Whats-App-Image-2025-09-04-at-1-31-43-AM-5-removebg-preview.png" 
            alt="Video Creator and Photographer Logo" 
            className="ad-logo"
          />
          <h3>VIDEO CREATOR</h3>
          <h3>PHOTOGRAPHER</h3>
          <div className="contact-info">
            <p><strong>WhatsApp:</strong> <a href="https://wa.me/96560002067" target="_blank" rel="noopener noreferrer">+965 6000 2067</a></p>
            <p><strong>Email:</strong> <a href="mailto:decorator.eng@gmail.com">decorator.eng@gmail.com</a></p>
            <p><strong>Contact:</strong> Ali Aminiyan</p>
          </div>
        </div>
      </section>

      <section className="home-image-section">
        <img 
          src="https://rbxatpcasybysywbddvh.supabase.co/storage/v1/object/public/images/WhatsApp%20Image%202026-01-25%20at%204.17.27%20AM%20(1).jpeg" 
          alt="Life Force Dynamics" 
          className="home-end-image"
        />
      </section>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Life Force Dynamics. All rights reserved.</p>
      </footer>
    </div>
  );
}

function PageWithNavbar({ children }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  return (
    <div className="main-bg">
      <Header isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} toggleMobileMenu={toggleMobileMenu} />
      {children}
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <WhatsAppButton />
      <Routes>
        <Route path="/" element={<HomeWrapper />} />
        <Route path="/shop" element={<PageWithNavbar><Shop /></PageWithNavbar>} />
        <Route path="/about-mana" element={<PageWithNavbar><AboutMana /></PageWithNavbar>} />
        <Route path="/courses" element={<PageWithNavbar><Courses /></PageWithNavbar>} />
        <Route path="/books" element={<PageWithNavbar><Books /></PageWithNavbar>} />
        <Route path="/books/:bookKey" element={<PageWithNavbar><BookDetail /></PageWithNavbar>} />
        <Route path="/art" element={<PageWithNavbar><ArtPrints /></PageWithNavbar>} />
        <Route path="/consultations" element={<PageWithNavbar><Consultations /></PageWithNavbar>} />
        <Route path="/planner" element={<PageWithNavbar><Planner /></PageWithNavbar>} />
        <Route path="/account" element={<PageWithNavbar><Account /></PageWithNavbar>} />
        <Route path="/guide" element={<PageWithNavbar><Guide /></PageWithNavbar>} />
        <Route path="/cart" element={<PageWithNavbar><Cart /></PageWithNavbar>} />
        <Route path="/login" element={<PageWithNavbar><Login /></PageWithNavbar>} />
        <Route path="/signup" element={<PageWithNavbar><SignUp /></PageWithNavbar>} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admindashboard" element={<Admin />} />
        <Route path="/checkout/:course" element={<PageWithNavbar><Checkout /></PageWithNavbar>} />
        <Route path="/thankyou" element={<PageWithNavbar><ThankYou /></PageWithNavbar>} />
        <Route path="/books/checkout" element={<PageWithNavbar><BooksCheckout /></PageWithNavbar>} />
        <Route path="/books/thankyou" element={<PageWithNavbar><BooksThankYou /></PageWithNavbar>} />
      </Routes>
    </CartProvider>
  );
}

function HomeWrapper() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  return <Home isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} toggleMobileMenu={toggleMobileMenu} />;
}

export default App;
